import { EventTypes, track, getPageSource } from '@mc/track-event'
import { BOGO_PROPS } from '../../lib/constants'

export const trackBogoPromoModalTermsClicked = (action: string) =>
  track(EventTypes.MODAL_CLICKED, {
    action,
    modal_type: BOGO_PROPS.PROMO_MODAL.MODAL_TYPE,
    page_source: getPageSource(),
    location: BOGO_PROPS.PROMO_MODAL.LOCATION,
  })

export const trackBogoPromoModalCtaClicked = (action: string) =>
  track(EventTypes.MODAL_CLICKED, {
    action,
    modal_type: BOGO_PROPS.PROMO_MODAL.MODAL_TYPE,
    page_source: getPageSource(),
    location: BOGO_PROPS.PROMO_MODAL.LOCATION,
  })

export const trackBogoPromoModalCloseClicked = (
  action: string = BOGO_PROPS.PROMO_MODAL.ACTIONS.CLOSE,
) =>
  track(EventTypes.MODAL_CLICKED, {
    action,
    modal_type: BOGO_PROPS.PROMO_MODAL.MODAL_TYPE,
    page_source: getPageSource(),
    location: BOGO_PROPS.PROMO_MODAL.LOCATION,
  })
